import { Typography } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { TRANSFER_REASON_OPTIONS } from "../../constants"
import type { TransferFormValues } from "../../schemas/transfer"

import { TransferFormDocuments } from "./TransferFormDocuments"

import { FormSelect } from "@/components/UiKit/FormControls/FormSelect"
import { FormTextField } from "@/components/UiKit/FormControls/FormTextField"
import type { UploadRowStatus } from "@/components/upload/MultiFileUpload/types"
import type { SignedUrl } from "@/graphql/codegen/graphql"

interface TransferFormDetailsProps {
  documents: SignedUrl[]
  onDocumentDelete: (document: SignedUrl) => void
  documentUploadStatuses: Record<string, UploadRowStatus>
  isUpdatingDocuments: boolean
  readOnly?: boolean
}

export const TransferFormDetails: FC<TransferFormDetailsProps> = ({
  documents,
  onDocumentDelete,
  documentUploadStatuses,
  isUpdatingDocuments,
  readOnly = false,
}) => {
  const { control } = useFormContext<TransferFormValues>()

  return (
    <div className='flex flex-col overflow-hidden rounded-lg border border-gray-400'>
      <Typography variant='h6' className='p-6 font-bold leading-10 text-gray-800'>
        Transfer Details
      </Typography>
      <div className='flex min-h-0 flex-1 flex-col gap-y-6 overflow-y-auto px-6 pb-6'>
        <FormSelect
          control={control}
          name='reason'
          label='Transfer Reason'
          placeholder='Select one'
          options={TRANSFER_REASON_OPTIONS}
          disabled={readOnly}
          data-testid='transfer.form-details.reason-field'
        />
        <FormTextField
          control={control}
          name='comment'
          label='Comment'
          placeholder='Enter comment'
          multiline
          rows={4}
          disabled={readOnly}
          data-testid='transfer.form-details.comment-field'
        />
        <TransferFormDocuments
          documents={documents}
          onDelete={onDocumentDelete}
          statuses={documentUploadStatuses}
          isUploading={isUpdatingDocuments}
          readOnly={readOnly}
        />
      </div>
    </div>
  )
}
